import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import RTL from "../../../../components/RTL";
import moment from "moment";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import mockData from "./../../../AddCompany/components/CompanyList/data";
import bars from './../../../bar'
import cars from './../../../car'

import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  input: {
    marginTop: theme.spacing(4),
    textAlign: "center",
    width: "100%",

    backgroundColor: "white",
  },

  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },

  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
    marginLeft: theme.spacing(2),
  },

  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  gridToolbar: {
    marginRight: 10,
  },
  inputGroup: {
    marginTop: theme.spacing(6),
  },
  button: {
    textAlign: "center",
    width: "100%",

    marginTop: theme.spacing(4),
    color:'#273C75',
    paddingLeft:25,
    marginRight: theme.spacing(1),
    padding:theme.spacing(2),
    '&:hover': {
      backgroundColor: "#273C75",
      color:'white'
   },
   

  },
 
}));

const ShipmentToolbar = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();
  // const [selectedDate, handleDateChange] = useState(moment());
  const [selectedDate, handleDateChange] = useState(null);

  return (
    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
      <RTL>
        <Grid container >
        <Grid
            className={classes.gridToolbar}
            alignItems="flex-start"
            item
            xs={3}
            sm={3}
          >
            <DatePicker
              className={classes.input}
              inputVariant="outlined"
              okLabel="تأیید"
              cancelLabel="لغو"
              label="تاریخ بارنامه"
              labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
              value={selectedDate ? moment(selectedDate) : null}             
               onChange={handleDateChange}
            />
          </Grid>
          <Grid
            className={classes.gridToolbar}
            alignItems="flex-start"
            item
            xs={3}
            sm={3}
          >
               <Autocomplete
              id="ComboboxCompany"
              options={cars}
              noOptionsText="همچنین ماشینی وجود ندارد"
              getOptionLabel={(option) => option.car}
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="نوع ماشین"
                  variant="outlined"
                />
              )}
            />
          </Grid>
        

          <Grid
            className={classes.gridToolbar}
            alignItems="flex-start"
            item
            xs={3}
            sm={3}
          >
            <Autocomplete
              id="ComboboxCompany"
              options={bars}
              noOptionsText="همچنین باری وجود ندارد"
              getOptionLabel={(option) => option.bar}
              renderInput={(params) => (
                <TextField
                  className={classes.input}
                  {...params}
                  label="نوع بار"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid
            className={classes.gridToolbar}
            alignItems="flex-start"
            item
            xs={3}
            sm={2}
          >
             <Button
        variant="outlined" 
        size='medium'
        color="secondary"
        className={classes.button}
        startIcon={<SearchIcon style={{marginLeft:5}} />}
      >

        اعمال فیلتر

      </Button>
          </Grid>
         
        </Grid>
      </RTL>
    </MuiPickersUtilsProvider>
  );
};

ShipmentToolbar.propTypes = {
  className: PropTypes.string,
};

export default ShipmentToolbar;
